import React from 'react';

export const getInitials = (name) => {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return parts[0].substring(0, 2).toUpperCase();
};

const AVATAR_COLORS = [
  '#008080',
  '#EE8B60',
  '#6C5CE7',
  '#0984E3',
  '#249689',
  '#E17055',
  '#8E44AD',
  '#D63031',
];

const Avatar = ({ name, size = 36, color }) => {
  const initials = getInitials(name);
  let hash = 0;
  for (let i = 0; i < (name || '').length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const bg = color || AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];

  return (
    <div
      className="user-avatar"
      style={{
        width: size,
        height: size,
        fontSize: size > 40 ? '1rem' : '0.85rem',
        backgroundImage: 'none',
        backgroundColor: bg,
      }}
      title={name}
    >
      {initials}
    </div>
  );
};

export default Avatar;